import { useMeetingSelector } from "@kalyzee/kast-web-sdk";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { SurveyStatus } from "@kalyzee/kast-web-sdk/websocket";
import { ReactIcons } from "@kalyzee/kalyzee-ui";
import { useAppStoreDispatch } from "../../contexts/appStore/context";
import { MainClockElapsedRenderer } from "../renderers/mainClock";
import React from "react";
import { useMeetingContainerContext } from "../../contexts/meetingContainer/context";

export const SurveyBar = React.memo(() => {
  const { containerAPI } = useMeetingContainerContext();

  const [survey] = useMeetingSelector(containerAPI, "surveys", surveys => surveys?.[0]);
  const wbMode = useAppStoreSelector(state => state.workBoxMode);
  const dispatch = useAppStoreDispatch();

  if (wbMode === "survey") return null;
  if (!survey || survey.status !== SurveyStatus.Open) return null;

  const question = survey.questions?.[0];
  if (!question) return null;
  return (
    <div 
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "1em",
        backgroundColor: "var(--color-element-survey-bar-bg)",
        color: "white",
        padding: "0.5em",
        cursor: "pointer",
      }}
      onClick={() => dispatch("setWorkBoxMode", "survey")}
    >
      <ReactIcons.Stats style={{ height: "1em", width: "1em" }} />
      {question.content}
      <MainClockElapsedRenderer
        since={survey.createdAt}
        render={elapsed => (
          <div style={{ opacity: 0.75, display: "flex", gap: "0.25em", fontSize: "1em", alignItems: "center" }}>
            <ReactIcons.Timer style={{ height: "1em" }} />
            {elapsed}
          </div>
        )}
      />
    </div>
  );
});
